import { Marked } from 'marked';
import TurndownService from 'turndown';
import { sanitizeHtml } from '@tymely/utils';

export function exec(command: string, value?: string) {
    document.execCommand(command, false, value);
}

export function getCommonAncestorElement(range: Range) {
    let node = range.commonAncestorContainer;
    while (node && node.nodeType !== Node.ELEMENT_NODE) {
        node = node.parentNode!;
    }
    return node as HTMLElement;
}

export function cleanHtml(html: string) {
    return sanitizeHtml(html.replace(/<(\/)?br(\/)?>/g, '\n')).replace(/^\s+|\s+$/g, '');
}

const marked = new Marked();

export function markdownToHtml(markdown: string): string {
    return marked.parse(markdown) as string;
}

const turndownService = new TurndownService();

export function htmlToMarkdown(html: string): string {
    return turndownService.turndown(html);
}
